export const Index = r => require.ensure([], () => r(require('./index')), 'dashboard-bundle');

export default [
  {
    path: '/',
    name: 'dashboard',
    component: Index
  }
];
